module.exports = "../../../../platform/assets/pageMainIcon/youth_yewushezhilei5.svg";